import React from 'react';
import About from '../about';

const AboutPage = () => <About />;

export default AboutPage;
